import { TlscpEntityVariant } from '@/generated/gql/graphql';

import { useMaskedBiddingByEntity } from './useMaskedBiddingByEntity';

interface UseMaskedBiddingBusinessLogProps {
  entityId: string;
  entityVariant: TlscpEntityVariant;
}

export const useMaskedBiddingBusinessLog = ({ entityId, entityVariant }: UseMaskedBiddingBusinessLogProps) => {
  const { isMaskedBidding } = useMaskedBiddingByEntity(entityId, entityVariant);

  const isMaskedNegotiationCaseLog = isMaskedBidding && entityVariant === TlscpEntityVariant.NEGOTIATION_CASE;
  const isMaskedDemandLog = isMaskedBidding && entityVariant === TlscpEntityVariant.DEMAND;
  const disableQueryChildren = isMaskedNegotiationCaseLog || isMaskedDemandLog;

  return {
    isMaskedBidding,
    isMaskedNegotiationCaseLog,
    isMaskedDemandLog,
    disableQueryChildren,
  };
};
